module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic33.fbe36d9.woff2";